import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { RoutePrefixField, validateRoutePrefix } from './RoutePrefixField';

/** Campo `ui:field: RoutePrefixField` de la plantilla "Pedir una ruta pública". */
export const RoutePrefixFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'RoutePrefixField',
    component: RoutePrefixField,
    validation: validateRoutePrefix,
  }),
);
